import React, { useState, useContext, useEffect } from 'react';

import { CircularProgress } from '@mui/material';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { Context as AuthContext } from '../../../contexts/authContext';
import { MDBox } from '../../MDBox';
import { MDInput } from '../../MDInput';
import { MDTypography } from '../../MDTypography';
import { MDButton } from '../../MDButton';
import bgImage from '../../../assets/images/illustrations/illustration-reset.jpg';
import { IllustrationLayout } from '../../layout/IllustrationLayout';

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    padding: theme.spacing(2, 0),
  },
}));

export default function ResetPasswordForm() {
  const classes = useStyles();
  const [password, setPassword] = useState('');
  const [rePassword, setRePassword] = useState('');
  const [userParams, setUserParams] = useState({ email: '', token: '' });

  const [isPasswordMatch, setIsPasswordMatch] = useState(true);
  const [isPasswordChanged, setIsPasswordChanged] = useState(false);
  const { isLoading, errors, clearState, resetPassword } =
    useContext(AuthContext);

  useEffect(() => {
    const url = new URL(window.location.href);
    const email = decodeURIComponent(url.searchParams.get('email') || '');
    const token = decodeURIComponent(url.searchParams.get('token') || '');
    setUserParams({ email, token });
  }, []);

  const onClick = async () => {
    if (password !== rePassword) {
      setIsPasswordMatch(false);
      return;
    }
    if (!isPasswordChanged) {
      if (resetPassword) {
        const successResponse = await resetPassword(
          userParams.email,
          password,
          rePassword,
          userParams.token
        );
        if (successResponse) {
          setIsPasswordChanged(true);
        }
      }
    }
  };
  const onFocus = () => {
    if (clearState) {
      clearState();
    }
  };

  return (
    <IllustrationLayout
      title="Reset Password"
      description="Enter your new password"
      illustration={bgImage}
    >
      <MDBox component="form" role="form">
        <MDBox mb={2}>
          <MDInput
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="newPassword"
            label="New Password"
            name="password"
            autoComplete="password"
            type="password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={
              (errors && errors.password && errors.password.length > 0) ||
              undefined
            }
            helperText={errors && errors.password && errors.password[0]}
            onFocus={onFocus}
          />
        </MDBox>
        <MDBox mb={2}>
          <MDInput
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="newPassword"
            label="Re Enter Password"
            name="repassword"
            autoComplete="password"
            type="password"
            value={rePassword}
            onChange={(e) => setRePassword(e.target.value)}
            error={!isPasswordMatch}
            helperText={!isPasswordMatch ? 'Passwords do not match' : undefined}
            onFocus={() => setIsPasswordMatch(true)}
          />
        </MDBox>
        <MDButton
          fullWidth
          variant="gradient"
          color="info"
          onClick={onClick}
          disabled={isLoading || isPasswordChanged}
        >
          {!isLoading ? (
            'Change Password'
          ) : (
            <CircularProgress color="inherit" />
          )}
        </MDButton>
        {errors && errors.serverError && (
          <MDTypography color="error">{errors.serverError}</MDTypography>
        )}
        {isPasswordChanged && (
          <MDTypography color="info">
            Password Changed Successfully. Please sign in.
          </MDTypography>
        )}
        <Grid container>
          <Grid item xs>
            <Link href="/" variant="body2">
              Sign in
            </Link>
          </Grid>
          <Grid item>
            <Link href="/register" variant="body2">
              {"Don't have an account? Sign Up"}
            </Link>
          </Grid>
        </Grid>
        <Box mt={5}>
          <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://www.fairfare.co/">
              FairFare
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
          </Typography>
        </Box>
      </MDBox>
    </IllustrationLayout>
  );
}
